interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0A1628]/95 backdrop-blur-lg shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-[#0EA5E9] to-[#06B6D4] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">AI</span>
            </div>
            <div>
              <div className="text-white font-bold text-lg leading-tight">AiConnect</div>
              <div className="text-gray-400 text-xs">by Daily Nest Group</div>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('live-demos')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Live Demos
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Contact
            </button>
          </div>

          <button
            onClick={() => scrollToSection('live-demos')}
            className="bg-[#0EA5E9] hover:bg-[#0284C7] text-white px-6 py-2.5 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            View Live Demos
          </button>
        </div>
      </div>
    </nav>
  );
}
